import { RHFSelect } from './rhf-select';
import { RHFSwitch } from './rhf-switch';
import { RHFTextField } from './rhf-text-field';
import { RHFDatePicker } from './rhf-date-picker';
import { RHFNumberInput } from './rhf-number-input';
import { RHFToggleGroup } from './rhf-toggle-group';

/** Champs react-hook-form (shadcn) : à utiliser dans un `<Form>` */
export const Field = {
  Text: RHFTextField,
  Select: RHFSelect,
  Switch: RHFSwitch,
  NumberInput: RHFNumberInput,
  DatePicker: RHFDatePicker,
  ToggleGroup: RHFToggleGroup,
};
